import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { ObjectSelected } from 'modules/objects';
import { UserSelected } from 'modules/user';
import ReportKindCheckboxes from '../ReportFilterFields/ReportKindCheckboxes';
import ReportVatCheckboxes from '../ReportFilterFields/ReportVatCheckboxes';
import { usePaymentReport } from './context/ReportObjectPaymentsProvider';
import { usePaymentObjectOptions } from './model';
import type { PaymentReportState } from './model/reportObjectPayments';

const OffPaymentReportFilterForm = () => {
    const { t } = useTranslation('Reports');
    const report = usePaymentReport();
    const getObjects = usePaymentObjectOptions(report.payments);
    const { values, setFieldValue } = useFormikContext<PaymentReportState>();
    return (
        <>
            <ReportKindCheckboxes showSales={report.showSales} />
            <ReportVatCheckboxes />
            <ObjectSelected
                title={t('usersFields.object')}
                value={values.selectedObject}
                onChange={(object) => void setFieldValue('selectedObject', object)}
                getList={getObjects}
            />
            <UserSelected title={t('objectPayments.columns.owner')} value={values.owner} onChange={(user) => void setFieldValue('owner', user)} clearable />
            <UserSelected title={t('objectPayments.columns.author')} value={values.author} onChange={(user) => void setFieldValue('author', user)} clearable />
        </>
    );
};

export default OffPaymentReportFilterForm;
